module.exports = __webpack_public_path__ + "static/firebase-ae2023f3cf5939e3d20136f1f9b5e751.png";